import request from '@/CommonDP/utils/request';

export default {
  addEnterpriseDept(data) {
    return request.post(`/enterpriseDept/doc/insert`, data);
  },
  queryEnterpriseDept(data) {
    return request.post(`/enterpriseDept/doc/list`, data);
  },
  delEnterpriseDept(folderId) {
    return request.get(`/enterpriseDept/doc/delete?folderId=${folderId}`);
  },
  queryEnterpriseDeptEdit(id) {
    return request.get(`/enterpriseDept/doc/query/` + id);
  },
  updateEnterpriseDept(data) {
    return request.post(`/enterpriseDept/doc/update`, data);
  },
  enterpriseDeptAddFolder(data = {}) {
    return request.post("/enterpriseDept/doc/newFolder", data).then((res) => res);
  },
  // 回收站
  queryEnterpriseDeptRecycle(enterpriseId) {
    return request
      .get(`/enterpriseDept/doc/recycle/list?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  queryEnterpriseDeptManager(enterpriseId) {
    return request.get(`/enterpriseDept/doc/manager?enterpriseId=${enterpriseId}`);
  },
  queryDeleteNoPermissionFile(data) {
    return request.post("/doc/noPermission/delete", data).then((res) => res);
  }
};
